/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Keen_Slug_BiteInputs */

const en_deep_keen_slug_bite = /** @type {(inputs: Deep_Keen_Slug_BiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Round`)
};

const de_deep_keen_slug_bite = /** @type {(inputs: Deep_Keen_Slug_BiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runde`)
};

/**
* | output |
* | --- |
* | "Round" |
*
* @param {Deep_Keen_Slug_BiteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deep_keen_slug_bite = /** @type {((inputs?: Deep_Keen_Slug_BiteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Keen_Slug_BiteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deep_keen_slug_bite(inputs)
	return de_deep_keen_slug_bite(inputs)
});